<template>
  <nx-bform-group :label="requiredLabel(name)" v-bind="$attrs" ref="group">
    <slot>
      <nx-bform-input
        :name="name"
        :rules="{ required, chinese: true }"
        :value="$attrs.value"
        @input="$listeners.input"
        @hook:mounted="checkBlur()"
      />
    </slot>
  </nx-bform-group>
</template>
// @input="$listeners.input"
// @input="resetEmpty($listeners.input)($event)"
resetEmpty(cb) {
      console.log("111", cb);
      return (evt) => {
        if (evt === "" || !evt) {
          console.log("222", evt);
          this.$refs.group.validation.reset(); // https://vee-validate.logaretm.com/v3/api/validation-provider.html#methods
        } else {
          console.log("333", evt);
          cb(evt);
        }
      }
    },
<script>
import FormGroupMixin from "../form-group.mixin";
import $ from "jquery";

export default {
  mixins: [FormGroupMixin],
  computed: {
    name() {
      return this.label || this.$t("chineseName");
    }
  },
  methods: {
    checkBlur() {
      const group = $(this.$refs.group);
      $(this.$refs.group.$el).find('input').on('blur', function() {
        if (!this.value) {
          group[0].validation.reset()
        }
      })
    }
}
};
</script>

<i18n src="@/locales/registration.locale.json" />
